export function roundNumber(number = 0, decimalPlace = 0): number {
  decimalPlace = decimalPlace ?? 0
  number = number ?? 0
  const strNum = Number(`${number}e${decimalPlace}`)

  return Number(`${Math.round(strNum)}e-${decimalPlace}`)
}
